import React from 'react';

const CaptchaPrivacyPolicy = ({ style }) => (
  <span
    style={{
      display: 'block',
      fontFamily: 'Nunito Sans',
      fontSize: 14,
      color: '#69757A',
      textAlign: 'center',
      ...style,
    }}
  >
    This site is protected by reCAPTCHA and the Google&nbsp;
    <a href="https://policies.google.com/privacy">Privacy Policy</a> and&nbsp;
    <a href="https://policies.google.com/terms">Terms of Service</a> apply.
  </span>
);

export default CaptchaPrivacyPolicy;
